"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _MapEvent = _interopRequireDefault(require("./MapEvent.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/MapBrowserEvent
 */


/**
 * @classdesc
 * Events emitted as map browser events are instances of this type.
 * See {@link module:ol/PluggableMap~PluggableMap} for which events trigger a map browser event.
 * @template {UIEvent} EVENT
 */
var MapBrowserEvent =
/** @class */
function (_super) {
  __extends(MapBrowserEvent, _super);
  /**
   * @param {string} type Event type.
   * @param {import("./PluggableMap.js").default} map Map.
   * @param {EVENT} originalEvent Original event.
   * @param {boolean} [opt_dragging] Is the map currently being dragged?
   * @param {?import("./PluggableMap.js").FrameState} [opt_frameState] Frame state.
   */


  function MapBrowserEvent(type, map, originalEvent, opt_dragging, opt_frameState) {
    var _this = _super.call(this, type, map, opt_frameState) || this;
    /**
     * The original browser event.
     * @const
     * @type {EVENT}
     * @api
     */


    _this.originalEvent = originalEvent;
    /**
     * The map pixel relative to the viewport corresponding to the original browser event.
     * @type {?import("./pixel.js").Pixel}
     */

    _this.pixel_ = null;
    /**
     * The coordinate in the user projection corresponding to the original browser event.
     * @type {?import("./coordinate.js").Coordinate}
     */

    _this.coordinate_ = null;
    /**
     * Indicates if the map is currently being dragged. Only set for
     * `POINTERDRAG` and `POINTERMOVE` events. Default is `false`.
     *
     * @type {boolean}
     * @api
     */

    _this.dragging = opt_dragging !== undefined ? opt_dragging : false;
    return _this;
  }

  Object.defineProperty(MapBrowserEvent.prototype, "pixel", {
    /**
     * The map pixel relative to the viewport corresponding to the original event.
     * @type {import("./pixel.js").Pixel}
     * @api
     */
    get: function get() {
      if (!this.pixel_) {
        this.pixel_ = this.map.getEventPixel(this.originalEvent);
      }

      return this.pixel_;
    },
    set: function set(pixel) {
      this.pixel_ = pixel;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MapBrowserEvent.prototype, "coordinate", {
    /**
     * The coordinate corresponding to the original browser event.  This will be in the user
     * projection if one is set.  Otherwise it will be in the view projection.
     * @type {import("./coordinate.js").Coordinate}
     * @api
     */
    get: function get() {
      if (!this.coordinate_) {
        this.coordinate_ = this.map.getCoordinateFromPixel(this.pixel);
      }

      return this.coordinate_;
    },
    set: function set(coordinate) {
      this.coordinate_ = coordinate;
    },
    enumerable: false,
    configurable: true
  });
  /**
   * Prevents the default browser action.
   * See https://developer.mozilla.org/en-US/docs/Web/API/event.preventDefault.
   * @api
   */

  MapBrowserEvent.prototype.preventDefault = function () {
    _super.prototype.preventDefault.call(this);

    if ('preventDefault' in this.originalEvent) {
      /** @type {UIEvent} */
      this.originalEvent.preventDefault();
    }
  };
  /**
   * Prevents further propagation of the current event.
   * See https://developer.mozilla.org/en-US/docs/Web/API/event.stopPropagation.
   * @api
   */


  MapBrowserEvent.prototype.stopPropagation = function () {
    _super.prototype.stopPropagation.call(this);

    if ('stopPropagation' in this.originalEvent) {
      /** @type {UIEvent} */
      this.originalEvent.stopPropagation();
    }
  };

  return MapBrowserEvent;
}(_MapEvent["default"]);

var _default = MapBrowserEvent;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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